"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaults_1 = require("./defaults");
var quadkey_1 = require("../../utils/quadkey");
function getCurrentQuadkey(map, options) {
    if (options === void 0) { options = defaults_1.defaultOptions; }
    var _a = map.getCenter(), lat = _a.lat, lng = _a.lng;
    var detail = options.zoom ? options.zoom + 2 : Math.floor(map.getZoom());
    var quadkey = quadkey_1.locationToQuadkey({ lat: lat, lng: lng }, detail);
    return quadkey;
}
exports.getCurrentQuadkey = getCurrentQuadkey;
function getCenterQuadkeyLayers(map, options) {
    if (options === void 0) { options = defaults_1.defaultOptions; }
    var quadkey = getCurrentQuadkey(map, options);
    return [
        {
            id: 'center-quadkey',
            source: {
                type: 'geojson',
                data: {
                    type: 'FeatureCollection',
                    features: [
                        {
                            quadkey: quadkey,
                        },
                    ].map(quadkey_1.quadkeyType),
                },
            },
            type: 'line',
            layout: {},
            paint: {
                'line-color': '#F89D42',
                'line-opacity': 0.4,
                'line-width': 4,
            },
        },
    ];
}
exports.getCenterQuadkeyLayers = getCenterQuadkeyLayers;
//# sourceMappingURL=layers.js.map